import classNames from "classnames";
import React from "react";
import styles from "./ModalOverlay.module.scss";

type ModalOverlayProps = {
  show: boolean;
  children: React.ReactNode;
};

export const ModalOverlay = ({ show, children }: ModalOverlayProps) => {
  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.active]: show,
      })}
    >
      <div
        className={classNames(styles.content, {
          [styles.activeContent]: show,
        })}
      >
        {children}
      </div>
    </div>
  );
};
